import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { countrieListPath, countryAddPath, CountryAddUrlQueryParams, CountryListUrlQueryParams, CountryListUrlSortField, countryPath, CountryUrlQueryParams } from "./urls";
import CountryCreateComponent from "./views/CountryCreate";
import CountryDetailsComponent from "./views/CountryDetails";
import CountryListComponent from "./views/CountryList";


const CountryList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
    const qs = parseQs(location.search.substr(1));
    const params: CountryListUrlQueryParams = asSortParams(
        qs,
        CountryListUrlSortField
      );
    return <CountryListComponent params={params} />;
};

const CountryCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CountryAddUrlQueryParams = qs;
  return <CountryCreateComponent params={params} />;
};

const CountryDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: CountryUrlQueryParams = qs;
  return (
    <CountryDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};


export const CountrySection: React.FC = () => {
    const intl = useIntl();
  
    return (
      <>
        <WindowTitle title={intl.formatMessage(sectionNames.countries)} />
        <Switch>
          <Route exact path={countrieListPath} component={CountryList} />
          <Route exact path={countryAddPath} component={CountryCreate} />
          <Route path={countryPath(":id")} component={CountryDetails} />
        </Switch>
      </>
    );
  };
  
  export default CountrySection;
  